// extracted by mini-css-extract-plugin
export default {"knowledge-table":"KnowledgeBase_knowledge-table__WuqqO","header":"KnowledgeBase_header__rfL5n"};